import VueRouter from "vue-router";

import Callback from "@/pages/Callback";
// import Landing from "@/pages/Landing";
// import TarifRechner from "@/pages/TarifRechner";
import Editor from "@/editor/Editor";
import Checkout from "@/pages/Checkout";
import MeterUpload from "@/pages/MeterUpload";
// import ContractTermination from "@/pages/ContractTermination";
// import Information from "@/pages/Information";
// import MagazineOverview from "@/pages/MagazineOverview";
// import Article from "@/pages/Article";
import AbstractPage from "@/pages/AbstractPage";
import store from "@/store/store";

const routes = [
  {
    path: "/callback",
    name: "Callback",
    component: Callback,
  },
  { path: "/editor", component: Editor },
  { path: "/checkout", component: Checkout },
  { path: "/meter-upload", component: MeterUpload },
  { path: "/", component: AbstractPage },
  { path: "/:page", component: AbstractPage },
  { path: "/:type/:page", component: AbstractPage },
  // { path: "/brand/:data", component: Information },
  // { path: "/magazin/:article", component: Article },
  // { path: "/pm/:article", component: Article },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Back/forward, when the router has a position recorded for it
    if (savedPosition) {
      return savedPosition;
    }
    // #anchor and ?target= are handled by the page itself
    if (to.hash) {
      return { selector: to.hash };
    }
    if (to.query.target) {
      return false;
    }
    // Any other navigation starts at the top of the new page
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (
    from.path == "/checkout" &&
    to.path != "/belieferungsanfrage-erfolgreich" &&
    !(to.path == "/" && to.query.id == "27612")
  ) {
    if (
      !window.confirm(
        "Sind sie sicher, dass Sie den Checkout verlassen wollen?"
      )
    ) {
      return;
    }
  }
  if (from.path == "/editor") {
    console.log("Leave editor");
    if (
      !window.confirm(
        "Are you sure you want to leave the editor, unsaved changes will be lost?"
      )
    ) {
      return;
    }
  }
  if (to.path == "/checkout") {
    if (!store.getters.getselectedTarifAndOptions.isSelected) {
      next((to = "/"));
    }
  }
  next();
});
export default router;
